__turbopack_context__.v({
  "contact-card": "OPi-ia_contact-card",
  "contact-card__body": "OPi-ia_contact-card__body",
  "contact-card__content": "OPi-ia_contact-card__content",
  "contact-card__footer": "OPi-ia_contact-card__footer",
  "contact-card__image": "OPi-ia_contact-card__image",
  "contact-card__text": "OPi-ia_contact-card__text",
  "contact-card__text-scroll": "OPi-ia_contact-card__text-scroll",
  "contact-card__title": "OPi-ia_contact-card__title",
});
